<template>
	<div>
		<header-component />

		<div class="payMain">
			<div class="w1300">
				<div class="sucess flex-c">
					<div class="icBox flex-cc mr-20">
						<svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
							width="40" height="40">
							<path
								d="M512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024z m-49.590857-377.197714L315.977143 498.614857 219.428571 590.848c70.217143 37.814857 168.594286 106.788571 252.854858 213.723429C531.821714 692.662857 715.337143 463.725714 804.571429 443.245714c-14.409143-57.709714-22.528-166.034286 0-223.817143-183.003429 120.685714-342.162286 427.373714-342.162286 427.373715z"
								fill="#00ba0d"></path>
						</svg>
					</div>
					<div class="tit tit-30 fw700">订单提交成功，请尽快付款！</div>
				</div>

				<div class="con">
					<div class="left">
						<!-- 金额与剩余时间区域 -->
						<div class="amount-time">
							<div class="p1 tit-18">应付金额</div>
							<h2 class="amount tit-40 fw700">¥ {{ shu.dingdan.zongjia }}</h2>
							<p class="remain-time fw700">剩余时间：{{ remainTimeFormat }}</p>
						</div>
					</div>
					<div class="list">
						<ul>
							<li class="flex-sbc" v-for="(item, index) in shu.shangpinlie" :key="index">
								<div class="imgBox">
									<el-image :src="item.tu" fit="contain"></el-image>
								</div>

								<div class="info">
									<div class="name">{{ item.ming }}{{ item.guigeming}}</div>
									<div class="bom flex-sbc mt-20">
										<div class="price cor-6B6B">¥{{ item.jiage}}</div>
										<div class="num tit-14 cor-6B6B">x{{ item.shuliang }}</div>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>

				<div class="checkWay">
					<div class="p1 tit-18 cor-333">选择支付方式</div>

					<div class="way">
						<!-- <div class="item flex-c" :class="{ active: selectedMethod === 'yu_e' }"
							@click="selectedMethod = 'yu_e'">
							<div class="icBox flex-cc">
								<el-image style="width: 30px;height: 30px;" src="https://youliqi.hnydl.com.cn/gongyong/shangchuan/tu/33/2026/03/M921BWbqBiBIrBOY1gGZ1C424b1YcY.png" fit="contain"></el-image>
							</div>
							<div class="name">余额支付 总余额:{{shu.zong_yu_e}}元</div>
						</div>
						<div class="item flex-c" :class="{ active: selectedMethod === 'weixin' }"
							@click="selectedMethod = 'weixin'">
							<div class="icBox flex-cc">
								<svg viewBox="0 0 1228 1024" version="1.1" width="30" height="30">
									<path
										d="M530.8928 703.1296a41.472 41.472 0 0 1-35.7376-19.8144l-2.7136-5.5808L278.272 394.752a18.7392 18.7392 0 0 1-2.048-8.1408 19.968 19.968 0 0 1 20.48-19.3536c4.608 0 8.8576 1.4336 12.288 3.84l234.3936 139.9296a64.4096 64.4096 0 0 0 54.528 5.9392L1116.2624 204.8C1004.9536 80.896 821.76 0 614.4 0 275.0464 0 0 216.576 0 483.6352c0 145.7152 82.7392 276.8896 212.2752 365.5168a38.1952 38.1952 0 0 1 17.2032 31.488 44.4928 44.4928 0 0 1-2.1504 12.3904l-27.6992 97.4848c-1.3312 4.608-3.328 9.3696-3.328 14.1312 0 10.752 9.216 19.3536 20.48 19.3536 4.4032 0 8.0384-1.536 11.776-3.584l134.5536-73.3184c10.1376-5.5296 20.7872-8.96 32.6144-8.96 6.2976 0 12.288 0.9216 18.0736 2.5088 62.72 17.0496 130.4576 26.5728 200.5504 26.5728C953.7024 967.168 1228.8 750.592 1228.8 483.6352c0-80.9472-25.4464-157.1328-70.0416-224.1024l-604.9792 436.992-4.4544 2.4064a42.1376 42.1376 0 0 1-18.432 4.1984z"
										fill="#15BA11"></path>
								</svg>
							</div>
							<div class="name">微信支付</div>
						</div>
						<div class="item flex-c" :class="{ active: selectedMethod === 'zhifubao' }"
							@click="selectedMethod = 'zhifubao'">
							<div class="icBox flex-cc">
								<svg viewBox="0 0 1024 1024" version="1.1" width="30" height="30">
									<path
										d="M998.912 694.23616 998.912 215.06048c0-103.296-83.82464-187.12064-187.18208-187.12064L212.72064 27.93984C109.42976 27.93984 25.6 111.76448 25.6 215.06048l0 599.00928c0 103.29088 83.7632 187.11552 187.12064 187.11552l599.00928 0c92.03712 0 168.6272-66.54976 184.25856-154.08128-49.6384-21.4784-264.73984-114.37056-376.79616-167.84384-85.27872 103.30112-174.58688 165.28896-309.20704 165.28896s-224.47104-82.9184-213.70368-184.38656c7.1168-66.6112 52.80256-175.49824 251.23328-156.8256 104.57088 9.79456 152.448 29.32736 237.73696 57.48736 22.07744-40.44288 40.38144-84.98176 54.31296-132.36736L261.38624 428.45696l0-37.47328 187.11552 0L448.50176 323.70176 220.2624 323.70176l0-41.2416 228.23936 0L448.50176 185.37472c0 0 2.06848-15.21152 18.86208-15.21152l93.55776 0 0 112.29696 243.31776 0 0 41.2416-243.31776 0 0 67.28192 198.49728 0c-18.2528 74.27584-45.93152 142.52544-80.60416 202.14272C736.48128 613.9904 998.912 694.23616 998.912 694.23616L998.912 694.23616 998.912 694.23616 998.912 694.23616zM295.08608 780.30336c-142.22336 0-164.73088-89.7792-157.18912-127.31904 7.48032-37.3504 48.6656-86.07232 127.74912-86.07232 90.88 0 172.27264 23.23456 269.96736 70.79936C466.9952 727.08096 382.68416 780.30336 295.08608 780.30336L295.08608 780.30336 295.08608 780.30336z"
										fill="#009FE8"></path>
								</svg>
							</div>
							<div class="name">支付宝支付</div>
						</div> -->
						<div class="item flex-c" :class="{ active: selectedMethod === 'xianxia' }"
							@click="selectedMethod = 'xianxia'">
							<div class="icBox flex-cc">
								<el-image style="width: 30px;height: 30px;" src="https://youliqi.hnydl.com.cn/gongyong/shangchuan/tu/33/2026/03/a75Wt48W844GGNz4Lw4yW87WhWcCZK.png" fit="contain"></el-image>
							</div>
							<div class="name">线下支付</div>
						</div>
					</div>
				</div>

				<div class="subBtn">
					<div class="btn fw700 cur" @click="subPay">立即结算</div>
				</div>
			</div>
		</div>

		<el-dialog title="" :visible.sync="dialogVisible" class="paymentDialog">
			<!-- 根据选择的支付方式不同展示对应的内容 -->
			<div class="box">
				<!-- weixin Pay Content -->
				<div v-if="selectedMethod === 'weixin'" class="item weixin-pay">
					<div class="dialog-header">
						<div class="icBox flex-cc">
							<svg viewBox="0 0 1228 1024" version="1.1" width="50" height="50">
								<path
									d="M530.8928 703.1296a41.472 41.472 0 0 1-35.7376-19.8144l-2.7136-5.5808L278.272 394.752a18.7392 18.7392 0 0 1-2.048-8.1408 19.968 19.968 0 0 1 20.48-19.3536c4.608 0 8.8576 1.4336 12.288 3.84l234.3936 139.9296a64.4096 64.4096 0 0 0 54.528 5.9392L1116.2624 204.8C1004.9536 80.896 821.76 0 614.4 0 275.0464 0 0 216.576 0 483.6352c0 145.7152 82.7392 276.8896 212.2752 365.5168a38.1952 38.1952 0 0 1 17.2032 31.488 44.4928 44.4928 0 0 1-2.1504 12.3904l-27.6992 97.4848c-1.3312 4.608-3.328 9.3696-3.328 14.1312 0 10.752 9.216 19.3536 20.48 19.3536 4.4032 0 8.0384-1.536 11.776-3.584l134.5536-73.3184c10.1376-5.5296 20.7872-8.96 32.6144-8.96 6.2976 0 12.288 0.9216 18.0736 2.5088 62.72 17.0496 130.4576 26.5728 200.5504 26.5728C953.7024 967.168 1228.8 750.592 1228.8 483.6352c0-80.9472-25.4464-157.1328-70.0416-224.1024l-604.9792 436.992-4.4544 2.4064a42.1376 42.1376 0 0 1-18.432 4.1984z"
									fill="#15BA11"></path>
							</svg>
						</div>
						<div class="tip1 tit-20 cor-333 mt-20">打开微信扫描二维码支付</div>
						<div class="tip2 cor-333 mt-10">
							若已完成付款页面未跳转，请<el-link type="primary" :underline="false"
								@click="$router.push('/')">点击这里</el-link>
						</div>
					</div>
					<div class="qrcode">
						<img src="data:image/png;base64,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"
							alt="微信支付二维码" />
					</div>
				</div>

				<!-- zhifubao Content -->
				<div v-else class="item zhifubao-pay">
					<div class="dialog-header">
						<div class="icBox flex-cc">
							<svg viewBox="0 0 1024 1024" version="1.1" width="50" height="50">
								<path
									d="M998.912 694.23616 998.912 215.06048c0-103.296-83.82464-187.12064-187.18208-187.12064L212.72064 27.93984C109.42976 27.93984 25.6 111.76448 25.6 215.06048l0 599.00928c0 103.29088 83.7632 187.11552 187.12064 187.11552l599.00928 0c92.03712 0 168.6272-66.54976 184.25856-154.08128-49.6384-21.4784-264.73984-114.37056-376.79616-167.84384-85.27872 103.30112-174.58688 165.28896-309.20704 165.28896s-224.47104-82.9184-213.70368-184.38656c7.1168-66.6112 52.80256-175.49824 251.23328-156.8256 104.57088 9.79456 152.448 29.32736 237.73696 57.48736 22.07744-40.44288 40.38144-84.98176 54.31296-132.36736L261.38624 428.45696l0-37.47328 187.11552 0L448.50176 323.70176 220.2624 323.70176l0-41.2416 228.23936 0L448.50176 185.37472c0 0 2.06848-15.21152 18.86208-15.21152l93.55776 0 0 112.29696 243.31776 0 0 41.2416-243.31776 0 0 67.28192 198.49728 0c-18.2528 74.27584-45.93152 142.52544-80.60416 202.14272C736.48128 613.9904 998.912 694.23616 998.912 694.23616L998.912 694.23616 998.912 694.23616 998.912 694.23616zM295.08608 780.30336c-142.22336 0-164.73088-89.7792-157.18912-127.31904 7.48032-37.3504 48.6656-86.07232 127.74912-86.07232 90.88 0 172.27264 23.23456 269.96736 70.79936C466.9952 727.08096 382.68416 780.30336 295.08608 780.30336L295.08608 780.30336 295.08608 780.30336z"
									fill="#009FE8"></path>
							</svg>
						</div>
						<div class="tip1 tit-20 cor-333 mt-20">
							打开支付宝扫描二维码支付
						</div>
						<div class="tip2 cor-333 mt-10">
							若已完成付款页面未跳转，请<el-link type="primary" :underline="false"
								@click="$router.push('/')">点击这里</el-link>
						</div>
					</div>
					<div class="qrcode">
						<img src="data:image/png;base64,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"
							alt="支付宝支付二维码" />
					</div>
				</div>
			</div>
		</el-dialog>

		<footer-component />
	</div>
</template>

<script>
	import headerComponent from "@/components/header.vue";
	import footerComponent from "@/components/footer.vue";

	export default {
		name: "OrderPayment",

		components: {
			headerComponent,
			footerComponent,
		},
		data() {
			return {
				totalAmount: 98000.0, // 总金额
				remainTime: 600, // 剩余时间（秒，示例 00:03:24 即 3*60 +24 = 204 秒）
				orderList: [{
					imgUrl: require("@/assets/navTwo-img.png"), // 商品图标占位，替换实际地址
					name: "[灵犀X1] 整机套餐 全套组件",
					price: 108000.0,
					quantity: 1, // 商品数量
				}, ],

				selectedMethod: "yu_e", // 默认选中微信支付
				dialogVisible: false, // 支付弹窗
				dingdanid: '',
				ids: '',
				shu: {
					dingdan: {},
					shangpinlie: []
				}
			};
		},
		computed: {
			remainTimeFormat() {
				// 将剩余秒数转换为 00小时03分钟24秒 格式
				const hours = Math.floor(this.shu.dingdan.daojishi / 3600)
					.toString()
					.padStart(2, "0");
				const minutes = Math.floor((this.shu.dingdan.daojishi % 3600) / 60)
					.toString()
					.padStart(2, "0");
				const seconds = (this.shu.dingdan.daojishi % 60).toString().padStart(2, "0");
				return `${hours}小时${minutes}分钟${seconds}秒`;
			},
		},
		created() {
			var that = this;
			// 启动倒计时，每隔 1 秒更新剩余时间
			if (that.$route.params && that.$route.params.id) {
				that.dingdanid = that.$route.params.id;
			}
			if (that.$route.params && that.$route.params.ids) {
				that.ids = that.$route.params.ids;
			}
			that.$post('m=limitao&k=zhifu', {
				dingdanid: that.dingdanid
			}, function(shu) {
				// uni.hideLoading()
				if (shu.shi == 1) {
					that.shu = shu.shu;
					that.countdownTimer = setInterval(() => {
						if (that.shu.dingdan.daojishi > 0) {
							that.shu.dingdan.daojishi--;
						} else {
							clearInterval(that.countdownTimer);
							// 可在此处处理倒计时结束逻辑，比如提示订单失效等
							console.log("倒计时结束");
						}
					}, 1000);
					console.log(that.shu)
				} else if (shu.shi == 2) {
					that.ZhiFuChengGong();
					clearInterval(that.countdownTimer);
				} else {
					that.$xiaoxi(shu.shu);
					setTimeout(function() {
						this.$houtui()
					}, 2000)
				}
			});
		},

		methods: {
			// subPay() {
			//   this.dialogVisible = true;
			// },
			subPay: function() {
				var that = this;
				if (that.selectedMethod == '') {
					that.$xiaoxi('请选择支付方式');
					return false;
				}
				that.$post('m=limitao&k=zhifu', {
						dingdanid: that.dingdanid,
						c: 'zhifu',
						zhifuqudao: that.selectedMethod,
						// mima: that.mima
					},
					function(shu) {
						// console.log(shu)
						// that.$L(shu)
						if (shu.shi == 0) {
							that.$xiaoxi(shu.shu, 200);
						} else if (shu.shi == 2) {
							that.queren = 1;
							return false;
						} else if (that.selectedMethod == 'yu_e' || that.selectedMethod == 'xianxia') {
							that.ZhiFuChengGong();
						} else if (that.selectedMethod == 'weixin') {
							that.WeiXin(shu.shu);
						} else if (that.selectedMethod == 'zhifubao') {
							//#ifdef H5
							location.href = shu.shu
							//#endif
							//#ifndef H5
							that.zhifubao(shu.shu);
							//#endif
						}
					}
				);
			},
			WeiXin: function(shu) {
				var that = this;
				//公众号支付
				//#ifdef H5	
				if (that.$isWeixin()) {
					WeixinJSBridge.invoke(
						'getBrandWCPayRequest', {
							"appId": shu.appId,
							"timeStamp": shu.timeStamp,
							"nonceStr": shu.nonceStr,
							"package": shu.package,
							"signType": shu.signType,
							"paySign": shu.paySign
						},
						function(res) {
							if (res.err_msg == "get_brand_wcpay_request:ok") {
								// that.ZhiFuChengGong();
							} else if (res.err_msg == "get_brand_wcpay_request:cancel") {
								that.$xiaoxi('取消支付');
							} else {
								that.$xiaoxi('支付失败');
							}
						}
					);
				} else {
					window.location.href = shu.url;
				}
				//#endif
				//小程序支付
				//#ifdef MP-WEIXIN 
				uni.requestPayment({
					provider: 'wxpay',
					timeStamp: shu.timeStamp,
					nonceStr: shu.nonceStr,
					package: shu.package,
					signType: shu.signType,
					paySign: shu.paySign,
					success: function(res) {
						that.ZhiFuChengGong();
					},
					fail: function(err) {
						console.log(err);
						that.$xiaoxi('取消支付');
					},
					complete: function(res) {
						console.log(res)
					}
				});
				//#endif
				//APP微信支付
				//#ifdef APP-PLUS 	
				console.log(shu);
				uni.requestPayment({
					provider: 'wxpay',
					orderInfo: shu,
					success: function(res) {
						that.ZhiFuChengGong();
					},
					fail: function(err) {
						console.log(err)
						that.$xiaoxi('取消支付');
					}
				});
				//#endif

				//抖音微信支付
				//#ifdef MP-TOUTIAO			
				tt.pay({
					orderInfo: {
						order_id: shu.order_id,
						order_token: shu.order_token
					},
					service: 5,
					success(res) {
						if (res.code == 0) {
							that.ZhiFuChengGong()
						}
					},
					fail(res) {
						that.$xiaoxi('取消支付')
					},
				});
				//#endif
			},
			zhifubao: function(shu) {
				var that = this;
				uni.requestPayment({
					provider: 'alipay',
					orderInfo: shu, //订单数据
					success: function(res) {
						that.ZhiFuChengGong();
					},
					fail: function(err) {
						that.$xiaoxi('取消支付');
					}
				});
			},
			beforeDestroy() {
				// 组件销毁前清除定时器，避免内存泄漏
				clearInterval(this.countdownTimer);
			},
			ZhiFuChengGong: function() {
				var that = this;
				clearInterval(this.countdownTimer);
				that.$router.replace({
					name: 'order',
					params: {
						id: that.shu.dingdan.dingdanhao
					}
				});
				 // 额外清理路由历史栈，确保无法回退
				window.history.pushState(null, null, window.location.href);
				window.addEventListener('popstate', function() {
					window.history.pushState(null, null, window.location.href);
				});
				that.$xiaoxi('支付成功');
			}
		}
	};
</script>

<style lang="less" scoped>
	.payMain {
		padding: 0.6rem 0 1rem;

		.con {
			padding: 0.4rem;
			margin-top: 0.4rem;
			background: #f9f9f9;
			border-radius: 0.08rem;
			display: flex;
			align-items: flex-start;

			.left {
				padding-right: 1rem;
				border-right: 1px solid rgba(133, 133, 133, 0.2);

				.p1 {
					color: #4b4b4b;
				}

				.amount {
					color: #106ade;
				}
			}

			.list {
				padding-left: 1rem;
				flex: 1;

				li {
					padding: 0.2rem 0;

					.imgBox {
						width: 1rem;
						height: 1rem;
						margin-right: 0.5rem;

						.el-image {
							display: block;
							width: 100%;
							height: 100%;
						}
					}

					.info {
						flex: 1;
						max-width: calc(100% - 1.5rem);
					}

					&:first-child {
						padding-top: 0;
					}
				}
			}
		}

		.checkWay {
			margin-top: 0.5rem;

			.way {
				.item {
					width: 2rem;
					min-width: 150px;
					margin-top: 0.3rem;
					background: #f8f8f8;
					padding: 0.25rem 0.2rem;
					display: inline-flex;
					align-items: center;
					justify-content: center;
					margin-right: 0.3rem;
					border: 2px solid transparent;
					cursor: pointer;

					.icBox {
						margin-right: 0.15rem;

						svg path {
							fill: #9c9c9c;
						}
					}

					.name {
						color: #9c9c9c;
						word-break: break-all
					}

					&.active {
						background: #fff;
						border-color: #333;

						.icBox {
							svg path {
								fill: revert-layer;
							}
						}

						.name {
							color: #333;
						}
					}
				}
			}
		}

		.subBtn {
			margin-top: 0.5rem;

			.btn {
				background: #4090e5;
				border-radius: 100px;
				width: 4.3rem;
				padding: 0.14rem 0.1rem;
				text-align: center;
				color: #fff;
			}
		}
	}

	// 支付弹窗
	/deep/ .paymentDialog {
		.el-dialog {
			width: 700px;

			.el-dialog__body {
				max-height: 80vh;
				overflow-y: auto;
			}
		}

		.box .item {
			padding: 0.2rem 0.5rem;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.qrcode {
				width: 200px;
				height: 200px;

				img {
					width: 100%;
					height: 100%;
					display: block;
				}
			}
		}
	}
</style>